<template>
  <div class="sidebarhome" v-show="show">
    <transition name="fade" mode="out-in">
      <ul class="side-menu" v-if="show">
        <li @click="$router.push('/updatePassword')">
          <van-icon name="setting-o" class="setting" />修改密码
        </li>
        <li @click="signOut">
          <i class="iconfont icontuichu"></i>退出登录
        </li>
      </ul>
    </transition>
    <div class="shadow"></div>
  </div>
</template>

<script>
import { Dialog } from 'vant'
export default {
  data () {
    return {
      gdb3: false,
      gdb2: false,
      sample_type: this.util.getLS(this.api.sample_type)
    }
  },
  props: ['show'],
  components: {
    Dialog
  },
  methods: {
    signOut () {
      Dialog.confirm({
        message: '是否要退出当前账户？'
      }).then(() => {
        // on confirm
        localStorage.clear()
        this.$router.push('/login')
      }).catch(() => {
        // on cancel
      })
    },
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
    } else {
      this.gdb2 = true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/functions";
  .sidebarhome, .sidebarhome .shadow {
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
  .sidebarhome {
    position: fixed;
    z-index: 999;
  }
  .sidebarhome .shadow,
  .sidebarhome .side-menu {
    position: absolute;
  }
  .sidebarhome .side-menu {
    top: pxToRem(70px);
    right: pxToRem(20px);
    // height: 100%;
    width: 33%;
    background-color: #3d434b;
    padding: pxToRem(40px) pxToRem(30px) pxToRem(0px);
    z-index: 1000;
    // transition: all .5s;
  }
  .sidebarhome .side-menu:before {
    width: 0px;
    height: 0px;
    border-width: 12px;
    border-style: solid;
    border-color: transparent transparent #3d434b transparent;
    position: absolute;
    content: ' ';
    right: pxToRem(12px);
    top: pxToRem(-34px);
  }
  .shadow {
    background-color: rgba(0, 0, 0, .3);
  }
  .sidebarhome .side-menu li {
    color: #fff;
    padding: pxToRem(6px) 0;
    border-bottom: 0.5px solid #494F59;
    font-size: pxToRem(24px);
    margin-bottom: pxToRem(30px);
  }
  .sidebarhome .side-menu .close {
    border-bottom-width: 0;
    text-align: right;
  }
  .sidebarhome .side-menu .close .icon {
    width: pxToRem(30px);
  }

  .fade-enter-active {
    transition: all .3s ease;
  }
  .fade-leave-active {
    transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
  }
  .fade-enter, .slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
  }
  .icontuichu {
    margin-right: pxToRem(10px);
  }
  .sidebarhome .setting {
    font-size: 16px;
    margin-right: pxToRem(10px);
    vertical-align: text-top;
  }
</style>



// WEBPACK FOOTER //
// src/components/SideBarHome.vue